import * as TypeGraphQL from "type-graphql";
export var NewsArticleScalarFieldEnum;
(function (NewsArticleScalarFieldEnum) {
    NewsArticleScalarFieldEnum["id"] = "id";
    NewsArticleScalarFieldEnum["title"] = "title";
    NewsArticleScalarFieldEnum["content"] = "content";
    NewsArticleScalarFieldEnum["source"] = "source";
    NewsArticleScalarFieldEnum["sourceDomain"] = "sourceDomain";
    NewsArticleScalarFieldEnum["url"] = "url";
    NewsArticleScalarFieldEnum["sentiment"] = "sentiment";
    NewsArticleScalarFieldEnum["authors"] = "authors";
    NewsArticleScalarFieldEnum["summary"] = "summary";
    NewsArticleScalarFieldEnum["bannerImage"] = "bannerImage";
    NewsArticleScalarFieldEnum["timePublished"] = "timePublished";
    NewsArticleScalarFieldEnum["category"] = "category";
    NewsArticleScalarFieldEnum["topics"] = "topics";
    NewsArticleScalarFieldEnum["logo"] = "logo";
    NewsArticleScalarFieldEnum["createdAt"] = "createdAt";
    NewsArticleScalarFieldEnum["updatedAt"] = "updatedAt";
})(NewsArticleScalarFieldEnum || (NewsArticleScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(NewsArticleScalarFieldEnum, {
    name: "NewsArticleScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=NewsArticleScalarFieldEnum.js.map